import { useEffect, useState } from "react";

export const Preloader = () => {
  const [hidden, setHidden] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setHidden(true), 2800);
    const t2 = setTimeout(() => setGone(true), 3600);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  if (gone) return null;

  return (
    <div
      data-testid="preloader"
      className={`fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden bg-black transition-opacity duration-700 ${
        hidden ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <div className="relative flex items-center justify-center">
        {/* radiant rays */}
        <div className="pre-rays absolute h-[560px] w-[560px] rounded-full" />
        {/* core glow brightening from behind */}
        <div className="pre-glow absolute h-[460px] w-[460px] rounded-full" />
        {/* mascot */}
        <img
          src="/logo-glow.png"
          alt="Autonomous Dex"
          data-testid="preloader-mascot"
          className="pre-mascot relative z-10 w-[64vw] max-w-[380px] h-auto object-contain drop-shadow-[0_0_40px_rgba(34,211,238,0.6)]"
        />
      </div>

      {/* loading indicator */}
      <div className="absolute bottom-16 left-0 right-0 flex flex-col items-center gap-4">
        <div className="h-[3px] w-48 overflow-hidden rounded-full bg-white/10">
          <div className="pre-bar h-full w-1/3 rounded-full bg-gradient-to-r from-cyan-400 to-fuchsia-500" />
        </div>
        <p className="font-mono text-[11px] uppercase tracking-[0.4em] text-cyan-300/80">
          Initializing
        </p>
      </div>
    </div>
  );
};
